import {
  setSearchText,
  setIsInitialized,
  clear,
} from './actions';

import { 
  thunkClear,
  thunkSetSearchText,
  thunkLoadStateFromUrl,
} from './thunks';


export {
	// PURE ACTION CREATORS
  setSearchText,
  setIsInitialized,
  clear,

	// THUNKS
  thunkClear,
  thunkSetSearchText,
  thunkLoadStateFromUrl,
};

export default {
	// PURE ACTION CREATORS
	setSearchText,
  setIsInitialized,
  clear,

  // THUNKS
  thunkClear,
  thunkSetSearchText,
  thunkLoadStateFromUrl,
};
